// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3NBj0","disabled":"FileBtn_disabled__6hiRJ","warn":"FileBtn_warn__R3zM-","fade":"FileBtn_fade__18Q-L"};